<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="mini" v-model="venderCode" style="width: 150px " placeholder="供应商代码" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input size="mini" v-model="venderName" style="width: 150px " placeholder="供应商名称" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="applyStatus">
                        <el-select v-model="applyStatus" clearable placeholder="请选择" @change="getDataList">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询
                        </el-button>
                        <!-- <el-button type="primary" size="small" @click="methodFrozen()" style="margin-left:20px">冻结</el-button>
                        <el-button type="primary" size="small" @click="methodThaw()" style="margin-left:20px">解冻</el-button> -->
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                  border :header-cell-style="{background:'#f5f5f5'}">
            <!-- <el-table-column align="center" v-model="something" type="selection" width="55">
            </el-table-column> -->
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="applyformType" header-align="center" align="left" label="审批类型" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.applyformType }}
                </template>
            </el-table-column> -->
            <el-table-column prop="applyformNum" header-align="center" align="right" width="120" label="审批单号">
                    <template slot-scope="scope">
                        {{ scope.row.applyformNum }}
                    </template>
                </el-table-column>
                <el-table-column prop="supplierLevel" header-align="center" align="center" label="等级" min-width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.supplierLevel == '0'">潜在</span>
                    <span v-if="scope.row.supplierLevel == '1'">合格</span>
                    <span v-if="scope.row.supplierLevel == '2'">一次性</span>
                </template>
            </el-table-column>
            <el-table-column prop="venderCodeStorage" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCodeStorage }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                    {{ scope.row.venderName }}
                    <!-- <el-button type="text" @click="venderUserDetail(scope.row)"> {{ scope.row.venderName }}</el-button> -->
                </template>
            </el-table-column>

            <el-table-column prop="applyStatus" header-align="center" align="center" width="120" label="状态">
                    <template slot-scope="scope">
                        <span style="color:#67C23A" v-for="(item, index) in scope.row.applyStatus.split(',')" :key="index" size="mini" type="success">{{item}}<br></span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="pic"
                        header-align="center"
                        align="center"
                        width="120"
                        label="当前流程图示">
                    <template slot-scope="scope">
                        <el-link :disabled="scope.row.applyStatus === '流程结束'" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                    </template>
                </el-table-column>

                <!-- <el-table-column
                        prop="pic"
                        header-align="center"
                        align="center"
                        width="120"
                        label="评审附件">
                    <template slot-scope="scope">
                        <el-link type="primary" style="font-size: 12px;" @click="viewThawFile(scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                    </template>
                </el-table-column> -->

                <el-table-column prop="createdName" header-align="center" align="left" width="120" label="申请人">
                    <template slot-scope="scope">
                        {{ scope.row.createdName }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="remark" header-align="center" align="left" width="200" label="申请原因">
                    <template slot-scope="scope">
                        {{ scope.row.remark }}
                    </template>
                </el-table-column> -->
                <el-table-column prop="createTimeStr" header-align="center" align="right" width="200" label="申请日期" >
                    <template slot-scope="scope">
                        {{ scope.row.createTimeStr }}
                    </template>
                </el-table-column>

            <el-table-column prop="disReason" header-align="center" align="center" label="审批历史">
                    <template slot-scope="scope">
                        <el-button @click="doHistory(scope.row)">查看</el-button>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.taskActions" :key="index">
                            <!-- <el-button icon="el-icon-s-check" v-if="!item.flowRuleType" size="small" type="text"
                                       @click="execFinish(scope.row.id, item.taskId, scope.row.targetId)">
                                批准
                            </el-button> -->
                            <div v-if="item.flowRuleType && item.flowRuleType === 'action'">
                                <el-button icon="el-icon-circle-check" type="text" size="small"
                                           @click="execApprove(scope.row.id, item.taskId, item.flowRuleType, item.normalValue, scope.row.supplierInviteId)">通过
                                </el-button>
                                <el-button icon="el-icon-circle-close" type="text" size="small" style="color:#F56C6C"
                                           @click="execApprove2(scope.row.id, item.taskId, item.flowRuleType, item.reverseValue, scope.row.supplierInviteId)">驳回
                                </el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>

        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <!-- 文件列表 -->
        <freezing-file v-if="thawFileVisible" ref="freezingFile"></freezing-file>

        <el-dialog
                :visible.sync="showViewer"
                width="80%"
                title="流程图">
            <el-image :src="diagramUrl" style="margin-bottom: 120px;">
            </el-image>
        </el-dialog>

        <el-dialog :title="'提示'" width="30%" :close-on-click-modal="false" :visible.sync="unQuoteReasonFlag">
            <el-form label-width="0px" :rules="dataRule" :model="dataForm2" ref="dataForm2">
                <el-form-item prop="unQuoteReason">
                    <el-input type="textarea" :rows="2" placeholder="请输入驳回原因" v-model="dataForm2.unQuoteReason">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="unQuoteReasonFlag = false">取 消</el-button>
                <el-button type="primary" @click="UpdateBybohui()">确 定</el-button>
            </div>
        </el-dialog>

        <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
            <div v-for="str in historyList" :key="str">
                <el-descriptions :title="str.executeTime">
                        <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
                        <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
                </el-descriptions>
              <el-divider></el-divider>
            </div>
        </el-drawer>

    </div>
</template>
<script>
    import {listApplyForm,execTask3} from '@/controller/supplier'
    import AddOrUpdate from './supplier-info-add-or-update'
    import FreezingFile from './freezing-file'
    import { listAllStatus,getProcessDiagramCurrent,listCommentHistory} from '@/controller/workflow'
    export default {
        data() {
            return {
                dataForm: {
                    key: ''
                },

                dataForm2: {
                    unQuoteReason: '',
                    id : '',
                    taskId : '',
                    flowType : '',
                    val : '',
                    supplierInviteId:'',
                },
                applyStatus: '',
                showViewer: false,
                diagramUrl: '',

                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                dialogFormVisible: false,
                formLabelWidth: '120px',
          
                venderName: '',
            
              
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                
                dataRule: {
                    remarks: [
                        { required: true, message: '请填写驳回原因', trigger: 'blur' }
                    ],
                },

                addOrUpdateVisible: false,
                frozenThawVisible: false,
                thawFileVisible:false,
                unQuoteReasonFlag: false,

                venderCode : '',


                // 通过或驳回表单
                form: {
                        remarks: '',
                        id: '',
                        taskId:'', 
                        flowType:'', 
                        val:''
                    },
                // 审批历史
                drawer: false,
                // 审批列表
                historyList:[],
            }
        },

        components: {
            AddOrUpdate,FreezingFile
        },

        activated() {
            if (this.$route.query && this.$route.query.state && this.$route.query.state.length > 0) {
                this.applyStatus = this.$route.query.state
            }
            this.getDataList()
            this.getAllStatus()
        },

        methods: {

            dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },

            viewDiagram(id) {
                getProcessDiagramCurrent({id: id}).then(data => {
                    this.diagramUrl = data.body
                    this.showViewer = true
                })
            },

            // 显示文件列表
            viewThawFile(row){
                this.thawFileVisible = true
                this.$nextTick(() => {
                    this.$refs.freezingFile.init(row)
                })
            },

            // 查询状态列表
            getAllStatus(){
                listAllStatus({
                    'processDefKey': 'SCA'
                }).then(data => {
                    if (data && data.code === '00') {
                        this.options1 = data.body.map(str => {
                            return {'value': str, 'label': str}
                        })
                    }
                })
            },

            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                listApplyForm({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'venderCode': this.venderCode,
                    'venderName': this.venderName,
                    'key': this.dataForm.key,
                    'applyStatus': this.applyStatus,
                    'approvedBy': this.approvedBy,
                    'approveLevel': 0,
                    'applyformType': '11',
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        //  this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },

            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },

            //多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },

            //单选
            radioChange(row) {
                this.dataListSelections = row;
            },

            //已完成未完成筛选
            handleCheckAllChange() {
                this.pageIndex = 1
                this.getDataList()
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },

            //查看
            venderUserDetail(row) {
                row.isE = 0;
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(row)
                })
            },

            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },

            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },

            // 代码审批通过
            execApprove(id, taskId, flowType, val, supplierInviteId){
                this.$confirm(`确定进行通过操作?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                        execTask3({
                            'id': id,
                            'taskId': taskId,
                            'paramKey': flowType,
                            'paramVal': val,
                            'targetId':supplierInviteId,
                        }).then(data => {
                            if (data && data.code === '00') {
                                this.getDataList()
                            }
                        })

                    })
            },

            //驳回
            execApprove2(id, taskId, flowType, val, supplierInviteId) {
                this.dataForm2.unQuoteReason = ''
                this.dataForm2.id = id,
                this.dataForm2.taskId = taskId,
                this.dataForm2.flowType = flowType,
                this.dataForm2.val = val,
                this.dataForm2.supplierInviteId = supplierInviteId,

                this.unQuoteReasonFlag = true,
                
                console.log('驳回',this.dataForm)
            },

            // 驳回
            UpdateBybohui(){

            this.$confirm(`确定进行驳回操作?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                        let params = {
                          'id': this.dataForm2.id,
                          'taskId': this.dataForm2.taskId,
                          'paramKey': this.dataForm2.flowType,
                          'paramVal': this.dataForm2.val,
                          'targetId': this.dataForm2.supplierInviteId,
                          'unQuoteReason' : this.dataForm2.unQuoteReason,
                        }
                        //console.log(params)

                execTask3(params).then(data => {
                            if (data && data.code === '00') {
                                this.getDataList()
                            this.$message({
                                message: '驳回成功',
                                type: 'success',
                                duration: 500,
                                onClose: () => {
                                    this.visible = false
                                    this.$emit('refreshDataList')
                                    this.unQuoteReasonFlag = false
                                }
                            })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })

                    })

            },

            // 审批历史
            doHistory(row){
                this.historyList = []
                listCommentHistory({'workflowId' : row.workflowId}).then(data => {
                    if (data && data.code === '00') {
                        this.historyList = data.body
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                this.drawer = true

            },
            
        }
    }
</script>